// Added by Sejune Oh on 2019-06-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, RefObject } from 'react'
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import Search from '../../Search'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface SettingTemplateFCProps extends WithStyles<typeof styles> {
    pageDepth: Array<[string, string]>
    onSearch?: (key: string) => void
    defaultValue?: string
    autocomplete?: boolean
    searchRef?: RefObject<Search>
    hideBtn?: boolean
    hideSearch?: boolean
    messageComponent?: JSX.Element
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SettingTemplate: FC<SettingTemplateFCProps> = ({
    classes,
    defaultValue = '',
    autocomplete = false,
    hideBtn = true,
    hideSearch,
    messageComponent,
    children,
    ...props
}) => {
    const maxPageDepth = props.pageDepth.length - 1
    return (
        <div className={classes.SettingWrapper}>
            <div className={classes.SettingHeaderWrapper}>
                <span className={classes.LinkWrapper}>
                    {props.pageDepth.map(([dispName, pageLink], index) => (
                        <NavLink
                            key={index}
                            className={classNames(classes.NavLink, index === maxPageDepth ? classes.CurNavLink : '')}
                            to={pageLink}
                        >
                            {dispName}
                            {index !== maxPageDepth ? ' > ' : ''}
                        </NavLink>
                    ))}
                </span>
                {messageComponent}
                <span className={classes.SearchWrapper}>
                    {!hideSearch && (
                        <Search
                            onSearch={props.onSearch!}
                            defaultValue={defaultValue}
                            ref={props.searchRef}
                            autocomplete={autocomplete}
                            hideBtn={hideBtn}
                        />
                    )}
                </span>
            </div>
            <div className={classes.SettingContentWrapper}>{children}</div>
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        SettingWrapper: {
            maxWidth: '990px',
            width: '100%',
        },
        SettingHeaderWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: `${theme.spacing()}px 0`,
            alignItems: 'center',
            borderBottom: '1px solid rgb(99, 99, 99)',
            backgroundColor: '#303030',
            minHeight: '60px',
            position: 'fixed',
            maxWidth: '990px',
            width: '100%',
            zIndex: 2
        },
        SettingContentWrapper: {
            padding: `60px ${theme.spacing()}px 0 ${theme.spacing()}px`
        },
        LinkWrapper: {},
        NavLink: {
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.7)',
            textDecoration: 'unset',
        },
        CurNavLink: {
            color: '#fff',
        },
        SearchWrapper: {},
    })

export default withStyles(styles, { withTheme: true })(SettingTemplate)
